"use client";

import type { ResultOf } from "gql.tada";

import { Prose } from "~/components/prose";
import { StructuredText } from "~/components/structured-text";

import type { GUIDE_QUERY } from "../_lib/gql";
import { PlaceCard } from "./place-card";
import { TourCard } from "./tour-card";

export function Body({
  body,
}: {
  body: NonNullable<ResultOf<typeof GUIDE_QUERY>["guide"]>["body"];
}) {
  return (
    <Prose>
      <StructuredText
        data={body}
        classNames={{ ImageRecord: "rounded-xl" }}
        blockComponents={{
          PlaceCardRecord: PlaceCard,
          TourCardRecord: TourCard,
        }}
      />
    </Prose>
  );
}
